import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { ButtonComponent } from 'src/components/button/button.component';
import { FormService } from 'src/services/form.service';
import { IconModule } from 'src/components/icon/icon.module';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  standalone: true,
  imports: [DialogModule, ProgressSpinnerModule, IconModule, ButtonComponent],
})
export class DialogConfirmComponent {
  @Input()
  visible: boolean = false;

  @Output()
  visibleChange = new EventEmitter<boolean>();

  @Input()
  styleClass: string = '';

  @Input()
  title: string = '';

  @Input()
  description: string = '';

  @Input()
  confirmText: string = 'Simpan';

  @Input()
  confirmStyleClass: string = '';

  @Input()
  cancelText: string = 'Pastikan Lagi';

  @Input()
  cancelStyleClass: string = '';

  @Input()
  pending: boolean = false;

  @Output()
  submit = new EventEmitter<void>();

  protected formSubmitting: boolean = false;

  constructor(protected formService: FormService) {}

  protected _hide() {
    this.visibleChange.emit(false);
  }
}
